import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { markServerReachable, selectIsOnline, setOnline } from "../_api/networkSlice";

// Keeps network.isOnline in sync with the browser's link-layer state via
// the window online/offline events. Deliberately not a local useState -
// baseQuery.js also reads navigator.onLine directly (to decide "offline"
// vs "network" error kind on a request that already failed), so this and
// that need to agree on the same source of truth, which redux gives for
// free. Call this once, from OfflineBanner - it's the only consumer.
export const useOnlineStatus = () => {
  const dispatch = useDispatch();
  const isOnline = useSelector(selectIsOnline);

  useEffect(() => {
    const sync = () => dispatch(setOnline(navigator.onLine));
    sync(); // reconcile a transition that happened before mount
    // Optimistic: clears the "can't reach server" banner immediately on
    // reconnect rather than waiting for the next request to succeed. If
    // the server is genuinely still down, the next request re-flags it.
    const handleOnline = () => {
      sync();
      dispatch(markServerReachable());
    };
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", sync);
    };
  }, [dispatch]);

  return isOnline;
};
